import React, { useEffect, useState } from "react";
import "./styles/sign-in-up.css";
import { useNavigate } from "react-router-dom";

import { message } from "antd";

import { CheckCircleTwoTone } from "@ant-design/icons";
import { Popover, Row, Col, Form, Input, Button } from "antd";
import { useParams } from "react-router-dom";
import PasswordStrength from "../components/PasswordStrength";
import Axios from "../api/Axios";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
  LoadingOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setmessageSlice } from "../store/slices/messageSlice";
import { commonPasswords } from "../components/icons/ApplicationColor";
import ImagesSlider from "../components/ImagesSlider";
import { MAIN_LOGO_BIG } from "../ImagesSrc";

const SetPassword = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { uid, token } = useParams();

  const [successReset, setSuccessReset] = useState(false);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [passwordState, setPasswordState] = useState("");
  const [passName, setPassName] = useState("");
  const [passUID, setPassUID] = useState("");
  const [passCID, setPassCID] = useState("");
  // const verificationStatus = useSelector(
  //   (state) => state.verification.verificationStatus
  // );
  const verificationStatus = useSelector(
    (state) => state.verifyPassword.verificationStatus
  );
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPasswordState(newPassword);
    // form.setFieldsValue({ password: newPassword }); // Update form field value
  };
  // console.log(verificationStatus);

  const WrongPassword = (text) => {
    messageApi.open({
      type: "error",
      content: text,
      duration: 7,
    });
  };

  const history = useNavigate();

  const navigate = () => {
    history("/");
  };
  const checkPassword = async () => {
    try {
      const res = await Axios.get(`/passwordrules/${uid}/${token}/`);
      //console.log(res.data.detail);
      setPassName(res.data.detail.first_name);
      setPassUID(res.data.detail.user_id);
      setPassCID(res.data.detail.client_id);
    } catch (err) {
      //console.log(err);
    }
  };

  const handleFormSubmit = async (values) => {
    //console.log(values);
    try {
      await Axios.post(
        `/setpassword/${uid}/${token}/`,
        verificationStatus
          ? {
              password: values.password,
            }
          : {
              password: values.password,
              reset_password: true,
            }
      );
      //console.log(res);
      setSuccessReset(true);
      setLoading(false);
    } catch (err) {
      WrongPassword(err?.response?.data?.detail);
      setLoading(false);
      //console.log(err);
    }
  };
  useEffect(() => {
    const inputField = document.getElementById("inputFieldId");
    if (inputField) {
      inputField.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      });
    }
    checkPassword();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleConfirmPasswordPaste = (e) => {
    e.preventDefault();
  };
  const getPasswordRequirements = () => {
    const hasCapitalLetter = passwordState?.match(/[A-Z]/);
    const hasSmallLetter = passwordState?.match(/[a-z]/);
    const hasSpecialCharacter = passwordState?.match(/[_\W]/);

    const hasNumericCharacter = passwordState?.match(/[0-9]/);

    return [
      {
        text: "At least 1 capital and small letter",
        icon:
          hasCapitalLetter && hasSmallLetter ? (
            <CheckCircleOutlined
              style={{ color: "green", marginRight: "0.3rem" }}
            />
          ) : (
            <CloseCircleOutlined
              style={{ color: "red", marginRight: "0.3rem" }}
            />
          ),
      },
      {
        text: "At least 1 special and numeric character",
        icon:
          hasSpecialCharacter && hasNumericCharacter ? (
            <CheckCircleOutlined
              style={{ color: "green", marginRight: "0.3rem" }}
            />
          ) : (
            <CloseCircleOutlined
              style={{ color: "red", marginRight: "0.3rem" }}
            />
          ),
      },
      {
        text: "Minimum 8 characters",
        icon:
          passwordState?.length >= 8 ? (
            <CheckCircleOutlined
              style={{ color: "green", marginRight: "0.3rem" }}
            />
          ) : (
            <CloseCircleOutlined
              style={{ color: "red", marginRight: "0.3rem" }}
            />
          ),
      },
    ];
  };

  const content = (
    <ul
      className="password-requirements"
      style={{ paddingLeft: "0.5rem", listStyleType: "none" }}
    >
      {getPasswordRequirements().map((requirement, index) => (
        <li key={index} style={{ padding: "0.3rem" }}>
          {requirement.icon} {requirement.text}
        </li>
      ))}
    </ul>
  );

  const [passwordSuccess, setPasswordSuccess] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  useEffect(() => {
    const validatePassword = async () => {
      try {
        await form.validateFields(["password"]);
        setPasswordSuccess(true);
        setShowInfo(false);
      } catch (errorInfo) {
        //console.log("Password Validation Error:", errorInfo.errorFields);
        setPasswordSuccess(false);
      }
    };
    if (passwordState.length > 0) {
      validatePassword();
    }
  }, [form, passwordState]);
  const dispatch = useDispatch();
  const messageSlice = useSelector((state) => state.messageSlice);

  useEffect(() => {
    if (messageSlice) {
      messageApi.open({
        type: "warning",
        content: "Reset password is required on initial login",
        duration: 7,
      });

      dispatch(setmessageSlice(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageSlice, dispatch]);
  return (
    <div className="main-co">
      {contextHolder}
      <div className="cont" style={{ height: "58rem" }}>
        <div className="left">
          <img
            alt=""
            src={MAIN_LOGO_BIG}
            className="logo1"
            height={"37px"}
            width={"150px"}
          />
          <div className="signIn_text1">
            {verificationStatus ? "Set" : "Reset"} Password
          </div>

          {successReset ? (
            <>
              <div className="verified-user">
                Password is successfully {verificationStatus ? "set" : "reset"}{" "}
                &nbsp;
                <CheckCircleTwoTone twoToneColor="#52c41a" />
                <div style={{ marginTop: "1rem" }}>
                  To go back and login{" "}
                  <span
                    style={{ color: " #295BDC", cursor: "pointer" }}
                    onClick={navigate}
                  >
                    Click here
                  </span>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="text-para1">
                Refer the Password Strength meter and set a secure password
              </div>
              <Form
                form={form}
                initialValues={{
                  password: "",
                  confirmPassword: "",
                }}
                onFinish={(values) => {
                  if (!loading) {
                    form
                      .validateFields()
                      .then(() => {
                        setLoading(true);
                        handleFormSubmit(values);
                      })
                      .catch((errorInfo) => {
                        //console.log("Form validation failed:", errorInfo);
                      });
                  }
                }}
              >
                <Row gutter={10} style={{ paddingTop: "20px" }}>
                  <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          validator: (_, value) => {
                            if (!value) {
                              return Promise.reject("Password is required");
                            }
                            if (value.includes(" ")) {
                              return Promise.reject("Spaces are not allowed");
                            }
                            if (value.length < 8) {
                              return Promise.reject(
                                "Password must be at least 8 characters"
                              );
                            }
                            if (
                              commonPasswords.some((common) =>
                                value
                                  .toLowerCase()
                                  .includes(common.toLowerCase())
                              )
                            ) {
                              return Promise.reject(
                                "Commonly used passwords are not allowed"
                              );
                            }
                            if (
                              !/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[_\W])[A-Za-z\d_\W]{8,}$/.test(
                                value
                              )
                            ) {
                              setShowInfo(true);
                              return Promise.reject(
                                "Password should meet the criteria"
                              );
                            }

                            const lowercaseValue = value.toLowerCase();
                            const lowercaseName = passName.toLowerCase();
                            const lowercaseUID = passUID.toLowerCase();
                            const lowercaseCID = passCID.toLowerCase();

                            if (
                              lowercaseValue.includes(lowercaseName) &&
                              passName !== ""
                            ) {
                              return Promise.reject(
                                "Password should not contain your First Name"
                              );
                            }
                            if (
                              lowercaseValue.includes(lowercaseUID) &&
                              passUID !== ""
                            ) {
                              return Promise.reject(
                                "Password should not contain your User ID"
                              );
                            }
                            if (
                              lowercaseValue.includes(lowercaseCID) &&
                              passCID !== ""
                            ) {
                              return Promise.reject(
                                "Password should not contain your Client ID"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input.Password
                        placeholder="Password"
                        className="input-col1"
                        type="password"
                        onPaste={handleConfirmPasswordPaste}
                        onChange={handlePasswordChange}
                        iconRender={(visible) =>
                          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={2}>
                    {passwordSuccess ? (
                      <Popover content={content}>
                        <CheckCircleOutlined
                          style={{
                            marginLeft: "5px",
                            paddingTop: "15px",
                            color: "green",
                            fontSize: "2.1rem",
                            verticalAlign: "middle",
                            cursor: "pointer",
                          }}
                        />
                      </Popover>
                    ) : !passwordSuccess && passwordState.length !== 0 ? (
                      <Popover content={content} open={showInfo}>
                        <InfoCircleOutlined
                          style={{
                            color: "red",
                            fontSize: "2.1rem",
                            marginLeft: "5px",
                            paddingTop: "15px",
                            verticalAlign: "middle",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setShowInfo((prev) => !prev);
                          }}
                        />
                      </Popover>
                    ) : (
                      <Popover content={content}>
                        <InfoCircleOutlined
                          style={{
                            color: "orange",
                            fontSize: "2.1rem",
                            marginLeft: "5px",
                            paddingTop: "15px",
                            verticalAlign: "middle",
                            cursor: "pointer",
                          }}
                        />
                      </Popover>
                    )}
                  </Col>
                </Row>

                <Row gutter={5}>
                  <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                    <div className="strength-container">
                      <PasswordStrength password={passwordState} />
                    </div>
                  </Col>
                </Row>
                {/* <div className="pass-con">
                    <div className="password-box">
                      <input
                        placeholder="Confirm password"
                        className="input-col21"
                        type={hidePassword2 ? "text" : "password"}
                        name="confirmPassword"
                        onChange={handleChange}
                        value={values.confirmPassword}
                        onBlur={handleBlur}
                        onPaste={(e) => e.preventDefault()} // Prevent pasting
                        autoComplete="off" // You can set autoComplete to "off" if desired
                      />
                      <img
                        className="eye-logo"
                        src={hidePassword2 ? Eye : EyeOff}
                        alt=""
                        onClick={togglePasswordVisiblity2}
                      />
                    </div>
                  </div> */}
                <Row gutter={10} style={{ paddingTop: "25px" }}>
                  <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                    <Form.Item
                      name="confirmPassword"
                      rules={[
                        {
                          required: true,
                          message: "Confirm Password is required",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            const password = getFieldValue("password");
                            if (!value || password === value) {
                              return Promise.resolve();
                            }
                            return Promise.reject("Passwords do not match");
                          },
                        }),
                      ]}
                    >
                      <Input.Password
                        placeholder="Confirm Password"
                        className="input-col1"
                        type="password"
                        name="confirmPassword"
                        id="confirmPassword"
                        onPaste={handleConfirmPasswordPaste}
                        iconRender={(visible) =>
                          visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={20}>
                  <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                    <Form.Item>
                      <Button
                        className="button-29"
                        type="primary"
                        htmlType="submit"
                        style={{
                          marginTop: "0.5rem",
                          cursor: loading ? "not-allowed" : "pointer",
                        }}
                        disabled={loading}
                      >
                        CHANGE PASSWORD
                        {loading ? (
                          <LoadingOutlined />
                        ) : (
                          <LockOutlined style={{ fontSize: "17px" }} />
                        )}
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </>
          )}
        </div>
        <ImagesSlider />
      </div>
    </div>
  );
};

export default SetPassword;
